import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { PlusCircle } from "lucide-react";
import { Input, Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useThemes } from "../../themes/hooks";
import { PromptFragmentsMultiSelect } from "../../prompt-fragments/components";
import { useCreateManualCreatedSite } from "../hooks";

interface IManualCreatedSiteFormValues {
  url: string;
  themeId?: string;
  promptFragmentIds?: number[];
  requirements?: string;
}

interface IProps {
  customerId: number;
  onCreated: (createdSiteId: number) => void;
}

export const ManualCreatedSiteForm: React.FC<IProps> = ({ customerId, onCreated }) => {
  const { data: themesData } = useThemes();
  const { createManualCreatedSite, loading } = useCreateManualCreatedSite();
  const [justCreated, setJustCreated] = useState(false);

  const form = useForm<IManualCreatedSiteFormValues>({
    mode: "all",
    defaultValues: { promptFragmentIds: [] },
  });

  const handleCreate = async () => {
    const { url, themeId, promptFragmentIds, requirements } = form.getValues();
    if (!url) {
      form.setError("url", { message: "URL requise" });
      return;
    }

    const createdSiteId = await createManualCreatedSite({
      customerId,
      url,
      themeId: themeId ? +themeId : null,
      promptFragmentIds: promptFragmentIds?.length ? promptFragmentIds : null,
      requirements: requirements || null,
    });

    if (createdSiteId) {
      setJustCreated(true);
      onCreated(createdSiteId);
    }
  };

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input
          label="URL du site"
          className="w-full"
          {...form.register("url", { required: "URL requise" })}
          placeholder="https://scalance.pro/le-bistrot/"
        />

        <Select label="Thème du site (optionnel)" className="w-full" {...form.register("themeId")}>
          <option value="">-</option>
          {themesData?.themes?.results?.map((theme) => (
            <option key={theme.id} value={theme.id}>
              {theme.name}
            </option>
          ))}
        </Select>

        <PromptFragmentsMultiSelect form={form} />

        <Textarea
          label="Notes (optionnel)"
          className="w-full"
          {...form.register("requirements")}
          placeholder="Créé manuellement, hors process Hermes..."
        />
      </div>

      <div className="w-full mt-4">
        <Button
          variant="secondary"
          onClick={handleCreate}
          loading={loading}
          disabled={loading || justCreated}
        >
          <PlusCircle size={16} className="mr-2" />
          {justCreated ? "Site ajouté" : "Ajouter le site"}
        </Button>
      </div>
    </div>
  );
};
